import { WeatherAlertModel } from "./WeatherAlert.model";

export class WeatherAlert extends WeatherAlertModel {
    // Add custom methods here
}
